import {getContainerHistoryForAssociate} from "../../../../commons/api/GetContainerHistoryForAssociateResults";

export const getCompleteContainerHistoryForUser = async (userLoginId, startTime, endTime) => {
    let containerInfoResult = await getContainerHistoryForAssociate(
        userLoginId,
        100,
        null,
        startTime,
        endTime
    );
    let containerRecord = containerInfoResult.containerRecordList;
    let nextPageToken = containerInfoResult.nextPageToken;;
    while (nextPageToken) {
        let nextPageContainerResult = await getContainerHistoryForAssociate(
            userLoginId,
            100,
            nextPageToken,
            startTime,
            endTime
        );
        containerRecord = [...containerRecord, ...nextPageContainerResult.containerRecordList]
        nextPageToken = nextPageContainerResult.nextPageToken;
    }
    return containerRecord;
}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/GetContainerHistory.js